<script>
import { VueMaskDirective } from "v-mask";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email, length, max } from "vee-validate/dist/rules";
import { isValidDate } from "@/helper";

extend("email", { ...email, message: "This field is invalid." });
extend("required", { ...required, message: "This field is required." });
extend("phone_length", {
  ...length,
  message: "This field must be a valid phone number.",
});
extend("date_length", {
  ...length,
  message: "This field must be a valid date.",
});
extend("middle_initial_max", {
  ...max,
  message: "The middle initial may not be greater than 2 characters.",
});
extend("max_home_zipcode", {
  ...max,
  message: "Maximum number of zipcode digits is 6",
});
extend("date", {
  validate(value) {
    return isValidDate(value);
  },
  message: "This field must be a valid date",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    mask: VueMaskDirective,
  },
  props: ["input", "control", "steps", "errors", "previousStep", "currentStep"],
  computed: {
    currentStepId() {
      return this.currentStep.id || 1;
    },
  },
  methods: {
    onNextStep(locationID, event = "scheduling-step", options = {}) {
      const detail = {
        event,
        locationID,
        value: this.currentStepId,
        mode: this.$store.getters.flowType,
        ...options,
      };

      this.$emit("onnextstep", detail);
    },
  },
};
</script>
